export default {
    '系统繁忙，请稍后重试': 'System busy, please try again later',
    该应用没有保存图片的权限: 'Saving not allowed',
};
